import * as React from 'react';
import { Input, Button } from 'antd';
import { SendOutlined } from '@ant-design/icons';

const { TextArea } = Input;

interface ChatInputProps {
  inputValue: string;
  isLoading: boolean;
  classes: any;
  t: any;
  onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onSendMessage: () => void;
}

const ChatInput: React.FC<ChatInputProps> = ({
  inputValue,
  isLoading,
  classes,
  t,
  onInputChange,
  onKeyPress,
  onSendMessage
}) => {
  return (
    <div className={classes.inputContainer}>
      <div className={classes.inputWrapper}>
        <TextArea
          className={classes.input}
          value={inputValue}
          onChange={onInputChange}
          onKeyPress={onKeyPress}
          placeholder={t("Type your question here...")}
          autoSize={{ minRows: 1, maxRows: 3 }}
          disabled={isLoading}
          bordered={false}
        />
        <Button
          type="primary"
          icon={<SendOutlined />}
          className={classes.sendButton}
          onClick={onSendMessage}
          disabled={!inputValue.trim() || isLoading}
        />
      </div>
    </div>
  );
};

export default ChatInput; 